import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

import { FormModalProps } from './types';

export default makeStyles((theme: ApplicationMuiTheme) => ({
    root: {
        minWidth: '440px',
        width: '100%',
        padding: (props: FormModalProps) => (props.formType === 'actionForm' ? '.5rem' : '1.5rem')
    },
    paperWidthXl: { width: (props: FormModalProps) => (props.modalWidth ? `${props.modalWidth}` : '50%') },
    title: {
        padding: '1rem 1.5rem 1rem 2rem',
        fontSize: '1.5rem',
        color: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        fontWeight: 'bold' as 'bold'
    },
    cancelButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    actionHeader: {
        position: 'relative' as 'relative',
        height: '7rem',
        backgroundColor: theme?.app?.clientTheme.colors.primaryColorLight || '#009BDF'
    },
    actionHeaderTitle: {
        fontSize: '2.8rem',
        fontWeight: 'bold' as 'bold',
        color: '#FFFFFF',
        textAlign: 'center' as 'center',
        textTransform: 'uppercase'
    },
    actionCancelButton: {
        position: 'absolute' as 'absolute',
        top: 18,
        right: 18
    }
}));